import axios from '@/config/axios';

// initial state
const state = () => {
    return {
        profileData: null,
        responseStatus: null,
        message: ''
    };
};

const getters = {
    getProfile: state => state.profileData,
    getResponseStatus: state => state.responseStatus,
    getMessage: state => state.message
};

const mutations = {
    setProfile: (state, profile) => {
        state.profileData = profile;
    },
    setResponseStatus: (state, status) => {
        state.responseStatus = status;
    },
    setMessage: (state, message) => {
        state.message = message;
    }
};

const actions = {
    getProfile: async context => {
        try {
            let response = await axios.get('profile');
            context.commit('profile/setProfile', response.data.user, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});

        }
    },

    updateProfile: async (context, params) => {
        try {
            let response = await axios.post('profile', params);
            if (response.data) {
                context.rootState.auth.user.name = response.data.user.name;
                context.rootState.auth.user.dob = response.data.user.dob;
                context.rootState.auth.user.gender = response.data.user.gender;
            }
            window.response = response;
            context.commit('errors/setMessage', response.data.message, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
        }
    },
    updatePassword: async (context, params) => {
        try {
            context.commit('errors/clear', null, {root: true});
            let response = await axios.post('/auth/password-update', params);
            context.commit('errors/setMessage', response.data, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
